// types
import {
    CONJUNCTION_ID_TO_TYPES,
    CONJUNCTION_TYPES,
    IDataFormat,
    IFRConversionRules,
    IGetInviteInfo
} from '@sitegen/common/classes/friends-referral-api';
import { IPlayerHighestStats } from 'widgets/friends-referral/modules/friends-referral/friends-referral-store';
import { IRuleStatus } from './invitee.types';
// constants
import { DEFAULT_STAT_VALUE } from './invitee.constants';
import { DATA_FORMAT } from '@sitegen/common/constants';
// utils
import { formatUnit } from '../units-formatter';

export const getStatData = (
    rule: IFRConversionRules,
    playerStats: IPlayerHighestStats | null): { platform: string, value: string } => {
    const nameParts = (rule.paramName || rule.statsName || '').split('.');
    const name = nameParts[1] || nameParts[0] || '';

    return {
        platform: playerStats?.[name]?.platform ?? '',
        value: playerStats?.[name]?.value ?? DEFAULT_STAT_VALUE
    };
};

export const checkButtonAvailability = (rules: IFRConversionRules[], playerStats: IPlayerHighestStats | null): boolean => {
    return rules.every(rule => getStatData(rule, playerStats).value === DEFAULT_STAT_VALUE);
};

export const getStatsFormatting = (rule: IFRConversionRules, dataFormat?: IDataFormat[], ): DATA_FORMAT => {
    const dataFormatByRule = dataFormat && dataFormat.find(data => data.id === rule.id);
    return  dataFormatByRule ? dataFormatByRule.format : DATA_FORMAT.NUMBER;
};

export const getRulesStatuses = (
    rules: IFRConversionRules[],
    playerStats: IPlayerHighestStats | null,
    invitationInfo: IGetInviteInfo,
    dataFormat?: IDataFormat[]
): IRuleStatus[] => {
    return rules.map(rule => {
        const { platform, value } = getStatData(rule, playerStats);
        const statsFormatting = getStatsFormatting(rule, dataFormat);
        const formattedParamTreshold = formatUnit(rule.paramThreshold ?? +DEFAULT_STAT_VALUE, statsFormatting);
        const formattedStatValue = formatUnit(value, statsFormatting);
        return {
            id: rule.id,
            statValue: formattedStatValue,
            paramThreshold: formattedParamTreshold,
            username: invitationInfo.username,
            platform
        };
    });
};

export const getConjunctionType = (conjunction: number): CONJUNCTION_TYPES => CONJUNCTION_ID_TO_TYPES[conjunction];
